<template>
  <div>
    <b-card
      header="ZekkenJockey QR"
      header-tag="header"
      footer="カメラで読み取ってください。"
      footer-tag="footer"
      title="タイム一覧"
      class="text-center"
      >
      <b-card-body>
        <vue-qrcode v-if="targetText" :value="targetText" :options="option" tag="img"></vue-qrcode>
      </b-card-body>
      <!-- <b-card-text class="text-monospace">
       {{ targetUrl }}
      </b-card-text> -->
      <b-button @click="$router.go(-1)" variant="primary">戻る</b-button>
    </b-card>

  </div>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
  name: 'App',
  components: {
    VueQrcode
  },
  data () {
    return {
      targetUrl: '',
      inputText: '',
      targetText: '',
      option: {
        errorCorrectionLevel: 'M',
        maskPattern: 0,
        margin: 4,
        scale: 2,
        width: 300,
        color: {
          dark: '#000000FF',
          light: '#FFFFFFFF'
        }
      }
    }
  },
  mounted () {
    this.targetUrl = this.$route.query.targetUrl
    console.log('default query : ' + this.targetUrl)
    if (this.targetUrl !== '') {
      this.generate()
    }
  },
  methods: {
    generate: function () {
      this.targetText = this.targetUrl
      // this.$refs.titleimage.display = 'none'
      // document.getElementById('titleimage').style.display = 'none'
    }
  }
}
</script>

<style>
#qrpage_back {
  text-align : center;
}
</style>



// WEBPACK FOOTER //
// src/components/qr.vue